import { render, staticRenderFns } from "./DefinitionPopup.vue?vue&type=template&id=5b8f18e2&scoped=true&"
import script from "./DefinitionPopup.vue?vue&type=script&lang=ts&"
export * from "./DefinitionPopup.vue?vue&type=script&lang=ts&"
import style0 from "./DefinitionPopup.vue?vue&type=style&index=0&id=5b8f18e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8f18e2",
  null
  
)

export default component.exports